import Model from 'alto-orm/lib/orm/model';

export default class Canteen extends Model {
  // attrs: name (string), registerNumber (smallint)

  static nominativeName  = 'jídelna';
  static accusativeName  = 'jídelnu';
  static attrNameMapping = { discriminatorHTML: 'discriminator_html' };
};
